/**
 * Turns raw inventory special-offer strings (often abbreviated feed text like
 * "1mo free w/12+mo on sel flpln") into clean customer-facing copy.
 * Returns { headline: "1 MONTH FREE", detail: "Select floor plans with 12+ month lease" }.
 * Never mutates the underlying value — display only.
 */
const ABBREVIATIONS = [
  [/\bw\/\s*/gi, "with "],
  [/\bsel\.?\b/gi, "select"],
  [/\bflpln[s]?\b/gi, "floor plans"],
  [/\bfp[s]?\b/gi, "floor plans"],
  [/\bapt[s]?\b/gi, "apartments"],
  [/\bapp\s*fee/gi, "application fee"],
  [/\badmin\s*fee/gi, "admin fee"],
  [/\bdep\b/gi, "deposit"],
  [/\bimmed\b/gi, "immediate"],
  [/\bmo\b\.?/gi, "month"],
  [/\bmos\b\.?/gi, "months"],
  [/\bwk\b\.?/gi, "week"],
  [/\bwks\b\.?/gi, "weeks"],
  [/\bbr\b/gi, "bedroom"],
  [/\bba\b/gi, "bath"],
  [/\bavail\b/gi, "available"],
];

const expand = (s) => {
  let out = s;
  // "1mo" / "12+mo" / "2wks" → "1 month" / "12+ month" / "2 weeks"
  out = out.replace(/(\d+\+?)(mo|mos|wk|wks|br|ba)\b/gi, "$1 $2");
  ABBREVIATIONS.forEach(([re, rep]) => { out = out.replace(re, rep); });
  // Space out "a+b" joins but keep "12+" (number-plus) intact
  out = out.replace(/(?<!\d)\s*\+\s*/g, " + ").replace(/\s{2,}/g, " ").trim();
  // "12+ month" reads better as "12+ month lease" when no lease word follows
  out = out.replace(/(\d+\+?\s*months?)(?!\s*lease)(?=\s*(on|for|$))/i, "$1 lease");
  return out;
};

const sentence = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);

export const formatSpecial = (raw) => {
  if (!raw || typeof raw !== "string") return null;
  const expanded = expand(raw);
  const m = expanded.match(/^(.*?)\s+(on|with|for)\s+(.*)$/i);
  if (m) {
    const headline = m[1].replace(/\s*\+\s*$/, "");
    const clause = m[3];
    let detail;
    const swap = m[2].toLowerCase() === "with" && clause.match(/^(.*?)\s+on\s+(select\b.*)$/i);
    if (swap) detail = sentence(`${swap[2]} with ${swap[1]}`);          // "Select floor plans with 12+ month lease"
    else if (/^\s*select/i.test(clause)) detail = sentence(clause);
    else detail = sentence(`${m[2]} ${clause}`);
    return { headline: headline.toUpperCase(), detail };
  }
  return { headline: expanded.toUpperCase(), detail: "" };
};

export const PRICING_DISCLAIMER = "*Pricing and availability subject to change.";
export const startingAround = (value) =>
  value ? `Starting around $${Number(value).toLocaleString()}/mo*` : "";
